import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gmail.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-79d1214e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile_register" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Login", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = { class: "signin" }
const _hoisted_6 = { class: "mobile_signin" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile_signin_title" }, "Log In to Sixliv", -1))
const _hoisted_8 = { class: "form" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Account", -1))
const _hoisted_10 = { class: "inputWrapper" }
const _hoisted_11 = {
  key: 0,
  class: "error"
}
const _hoisted_12 = { class: "form" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "verify_label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Password"),
  /*#__PURE__*/_createElementVNode("span", { class: "sent" }, "Forgot?")
], -1))
const _hoisted_14 = { class: "inputWrapper" }
const _hoisted_15 = { class: "form" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, null, -1))
const _hoisted_17 = { class: "inputWrapper" }
const _hoisted_18 = { class: "join" }
const _hoisted_19 = { class: "registerAccount" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "registerAccountOr registerAccount" }, "OR", -1))
const _hoisted_21 = { class: "buttons" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, "Gmail")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ElButton = _resolveComponent("ElButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.store.handleCloseMobile && _ctx.store.handleCloseMobile(...args)))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_ArrowLeft)
          ]),
          _: 1
        })
      ]),
      _hoisted_3,
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.email,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.email) = $event)),
              class: "input",
              placeholder: "Please input Email"
            }, null, 8, ["modelValue"])
          ]),
          (_ctx.isValidEmail)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.isValidEmail), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_input, {
              type: "password",
              modelValue: _ctx.formData.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.password) = $event)),
              class: "input",
              placeholder: "Please input Password"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_el_button, {
                loading: _ctx.loading,
                onClick: _ctx.handleSubmit,
                class: "button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Login")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createTextVNode(" Don’t have an account? "),
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.store.handleOpenMobileSignUp && _ctx.store.handleOpenMobileSignUp(...args))),
            class: "hightText"
          }, "Sign Up")
        ]),
        _hoisted_20
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_ElButton, {
        class: "button",
        onClick: _ctx.handleLogin
      }, {
        default: _withCtx(() => [
          _hoisted_22
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}